<app-lista-dados
  [upTitulo]="'Lista de Regras do Usuário'"
  [upIcone]="'security'"
  [upCor]="'3F51B5'"
  [upDados]="usuarioRegras"
  [upColunas]="colunasListaDados"
  [upHabilitaEditarLinha]="true"
  [upHabilitaBotaoEditar]="false"
  [upHabilitaFiltroRapido]="true"
  [upLargura]="3"
  [upHabilitaContador]="true"
  [upCarregando]="!!subscription"
  (ueIniciarEdicaoLinha)="onIniciarEdicaoLinha($event)"
  (ueSalvarLinha)="onSalvarLinha($event)"
  (ueBotaoExcluir)="onDelete($event)">
</app-lista-dados>
